import { PulseLoader } from 'react-spinners';
import './style.css';
import { selectValues } from '../../routes/home2/loanSlice';
import { useSelector } from 'react-redux';
export default function AuthWithMono({ onClick, loading }) {
  const values = useSelector(selectValues);
  const { amountToBorrow, yearsInmonths } = values;
  const getDisabledState = () => amountToBorrow > 0 && yearsInmonths > 0;
  let disabled = getDisabledState();
  return (
    <button
      className={disabled ? 'monoBtn' : 'monoBtnDisabled'}
      onClick={onClick}
      disabled={!disabled}
    >
      {loading ? (
        <PulseLoader loading={loading} size={8} color="white" />
      ) : (
        `Request Loan`
      )}
    </button>
  );
}
